
define('template!ordersDetailOrderProductMixedOptionView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="options-container"></div>\n<div class="quantity">' +
((__t = ( quantity )) == null ? '' : __t) +
'</div>';

}
return __p
};});

